import { axios } from 'configs'
import type {
  TAdCodeAttributionsResponse,
  TAdCodeDetail,
  TAdCodeListResponse,
  TListAdCodesRequest,
  TUpsertAdCodeRequest,
} from 'types'

export const listAdCodes = async (
  params: TListAdCodesRequest = {},
): Promise<TAdCodeListResponse> => {
  const response = await axios.get<TAdCodeListResponse>('/ad-codes', { params })
  return response.data
}

/** ページや状態に依存しない、組織全体の保存済み媒体。 */
export const listAdCodeMedia = async (): Promise<string[]> => {
  const response = await axios.get<string[]>('/ad-codes/media')
  return response.data
}

export const getAdCode = async (
  adCodeId: number,
  params: Pick<
    TListAdCodesRequest,
    'from' | 'to' | 'excludeBlocked24h' | 'metrics'
  > = {},
): Promise<TAdCodeDetail> => {
  const response = await axios.get<TAdCodeDetail>(`/ad-codes/${adCodeId}`, {
    params,
  })
  return response.data
}

export const listAdCodeAttributions = async (
  adCodeId: number,
  page: number,
  params: Pick<TListAdCodesRequest, 'from' | 'to'> = {},
): Promise<TAdCodeAttributionsResponse> => {
  const response = await axios.get<TAdCodeAttributionsResponse>(
    `/ad-codes/${adCodeId}/attributions`,
    { params: { page, ...params } },
  )
  return response.data
}

export const createAdCode = async (
  request: TUpsertAdCodeRequest,
): Promise<TAdCodeDetail> => {
  const response = await axios.post<TAdCodeDetail>('/ad-codes', request)
  return response.data
}

export const updateAdCode = async (
  adCodeId: number,
  request: TUpsertAdCodeRequest,
): Promise<TAdCodeDetail> => {
  const response = await axios.patch<TAdCodeDetail>(
    `/ad-codes/${adCodeId}`,
    request,
  )
  return response.data
}

export const archiveAdCode = async (
  adCodeId: number,
  archived: boolean,
): Promise<TAdCodeDetail> => {
  const response = await axios.post<TAdCodeDetail>(
    `/ad-codes/${adCodeId}/${archived ? 'archive' : 'unarchive'}`,
  )
  return response.data
}
